import SeoHead from "@/components/SeoHead";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import AboutTeaser from "@/components/home/AboutTeaser";
import Services from "@/components/Services";
import AiSkillingTeaser from "@/components/home/AiSkillingTeaser";
import LatestNews from "@/components/LatestNews";
import CallToAction from "@/components/CallToAction";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <>
      <SeoHead
        title={{
          en: "AI-labbet | We create value with responsible AI",
          sv: "AI-labbet | Vi skapar affärsvärde genom ansvarsfull AI",
        }}
        description={{
          en: "AI-labbet provides AI strategy, governance, and skilling services. We help organizations create business value through responsible AI.",
          sv: "AI-labbet erbjuder tjänster inom AI-strategi, styrning och kompetens. Vi hjälper organisationer att skapa affärsvärde genom ansvarsfull AI.",
        }}
        path="/"
      />

      <div className="min-h-screen bg-background">
        <Header />
        <main>
          <Hero />
          <AboutTeaser />
          <Services />
          <AiSkillingTeaser />
          <LatestNews />
          <CallToAction />
        </main>
        <Footer />
      </div>
    </>
  );
};
export default Index;


